module.exports = {"profile":{"certificates":{"headline":"Auszeichnungen und Zertifikate","emptyText":"Auszeichnungen und Zertifikate"}}}